import MessagesInbox from '@efdigital/ll-xceed-v2/components/coaching/messaging/messages-inbox.gts';
import type { CoachingCoachMessagesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/messages';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface MessagesSignature {
  Args: {
    model: CoachingCoachMessagesModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Messages"}}

  <div class="coaching-messages-pane">
    <div class="row g-0 coaching-messages-row h-100">
      <div
        class="col-auto coaching-messages-inbox border-end d-none d-lg-flex flex-column min-h-0 flex-shrink-0 h-100 ll-bg-raised"
      >
        <MessagesInbox
          @conversations={{@model.conversations}}
          @role="coach"
          @searchInputId="coachMessengerSearch"
          class="h-100"
        />
      </div>

      <div
        class="col d-flex flex-column min-h-0 min-w-0 h-100 coaching-messages-outlet"
      >
        {{outlet}}
      </div>
    </div>
  </div>
</template> satisfies TOC<MessagesSignature>;
